import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import CountByHourBarChart, { ChartProp } from './CountByHourBarChart';
import DropDownButton, { DropDownMenu } from '../../shared/DropDownButton';
import ChartContainer from '../../shared/ChartContainer';
import { useTranslation } from 'react-i18next';

const exportMenus: DropDownMenu[] = [{ label: 'PDF', value: 'pdf' }, { label: 'CSV', value: 'csv' }];

const data: ChartProp[] = [
    {
        name: '12 AM',
        val: 329,
    },
    {
        name: '1 AM',
        val: 200,
    },
    {
        name: '2 AM',
        val: 300,
    },
    {
        name: '3 AM',
        val: 100,
    },
    {
        name: '4 AM',
        val: 278,
    },
    {
        name: '5 AM',
        val: 329,
    },
    {
        name: '6 AM',
        val: 339,
    },
    {
        name: '7 AM',
        val: 249,
    },
    {
        name: '8 AM',
        val: 169,
    },
    {
        name: '9 AM',
        val: 250,
    },
    {
        name: '10 AM',
        val: 300,
    },
    {
        name: '11 AM',
        val: 200,
    },
    {
        name: '12 PM',
        val: 278,
    },
    {
        name: '1 PM',
        val: 189,
    },
    {
        name: '2 PM',
        val: 239,
    },
    {
        name: '3 PM',
        val: 349,
    },
    {
        name: '4 PM',
        val: 249,
    },
    {
        name: '5 PM',
        val: 100,
    },
    {
        name: '6 PM',
        val: 300,
    },
    {
        name: '7 PM',
        val: 240,
    },
    {
        name: '8 PM',
        val: 124,
    },
    {
        name: '9 PM',
        val: 289,
    },
    {
        name: '10 PM',
        val: 139,
    },
    {
        name: '11 PM',
        val: 249,
    }
];

export const filterMenus: DropDownMenu[] = [
    { label: 'Today', value: 'today' },
    { label: 'Week', value: 'week' },
    { label: 'Month', value: 'month' }
];

export default function CountByHourCard() {
const { t } = useTranslation();

    return (
        <Grid item={true} xs={12} md={12} lg={11} >
            <FFPaper
                sx={{
                    alignItems: 'stretch',
                    flexDirection: 'row',
                    minHeight: 360
                }}
            >
                <Stack sx={{ width: '100%' }}>

                    <Stack direction="row" spacing={2} sx={{ pt: 2, pr: 2, pb: 1, pl: 2, flexWrap: 'wrap' }}>
                        <Title big={true} notooltip={true}>Count By Hour</Title>
                        <Stack direction="row" spacing={2} sx={{ pr: 1, pb: 1, mb: 1 }}>

                            <DropDownButton boxShadow={false} 
                                defaultLabel={t('app_export_data')}
                                color="text.primary" backgroundColor="button.main" fontSize={14} data={exportMenus} />

                              <DropDownButton defaultLabel='Today' fontSize={15} data={filterMenus} border={false} boxShadow={false} />
                        </Stack>
                    </Stack>

                    <ChartContainer>
                        <CountByHourBarChart data={data} />
                    </ChartContainer>
                </Stack>

            </FFPaper>

        </Grid>
    )
}